import React from 'react';
import { books, OWNER_NAME, type Book } from '../../data/coffeeTable';
type BookPileProps = {
  order: number[];
  openId: number;
  onPick: (id: number) => void;
  onClose: () => void;
};
function OpenBook({
  book
}: {
  book: Book;
}) {
  return <div className="ct-open-book" role="dialog" aria-label={`${book.title}, open`} data-id="element-174" data-mp="1te6hay7s1b9s">
      <div aria-hidden="true" className="absolute inset-x-[4%] -bottom-3.5 h-6 rounded-full bg-[rgba(30,75,72,0.22)]" data-id="element-175" data-mp="1ybycq27mrfiq" />
      <div className="absolute left-1/2 top-0 flex h-full w-1/2 flex-col gap-1.5 rounded-r-[10px] bg-[#FFFFFF] pb-3.5 pl-[18px] pr-4 pt-4 shadow-[inset_12px_0_14px_-12px_rgba(30,75,72,0.3)]" data-id="element-176" data-mp="1jminwrrntk5o">
        <span className="text-[10px] font-semibold uppercase tracking-[0.08em] text-[#B03F2B]" data-id="element-177" data-mp="1alu8bsmmbbqo">I underlined</span>
        <p className="text-sm font-semibold leading-snug text-[#1E4B48]" data-id="element-178" data-mp="1fknm7m5th4rd">{book.quote}</p>
        <span className="mt-1 text-[10px] font-semibold uppercase tracking-[0.08em] text-[#B03F2B]" data-id="element-179" data-mp="10ru6q0qjoomp">How it changed my design</span>
        <p className="text-[12.5px] leading-[1.45] text-[#4F5955]" data-id="element-180" data-mp="oa466kmxmc7z">{book.takeaway}</p>
        <a className="mt-auto text-[13px] font-medium text-[#1E4B48] underline decoration-[#E3E6E3] underline-offset-4 transition-[text-decoration-color] duration-150 hover:decoration-[#1E4B48]" href={book.notesUrl} data-id="element-181" data-mp="jb9mzhl1ylnc">
          Read my notes →
        </a>
      </div>
      <div className="ct-leaf" data-id="element-182" data-mp="5jw6kcify3wj">
        <div className="ct-leaf-face justify-between rounded-r-[10px] pb-[18px] pl-[22px] pr-[18px] pt-5 shadow-[inset_8px_0_0_rgba(0,0,0,0.07)]" style={{
        background: book.bg,
        color: book.fg
      }} data-id="element-183" data-mp="5j39y4d74us4">
          <span className="text-[22px] font-semibold leading-[1.15] tracking-[-0.01em]" data-id="element-184" data-mp="edrcvnvau0dr">{book.title}</span>
          <span className="text-[11.5px] font-semibold uppercase tracking-[0.08em]" data-id="element-185" data-mp="9jwt6kfp1leo">{book.author}</span>
        </div>
        <div className="ct-leaf-face ct-leaf-back items-center justify-center gap-2 rounded-l-[10px] p-[18px] shadow-[inset_-12px_0_14px_-12px_rgba(30,75,72,0.3)]" style={{
        background: book.inside,
        color: book.fg
      }} data-id="element-186" data-mp="3hz6tbn00wgjt">
          <div className="flex -rotate-[4deg] flex-col items-center gap-0.5 rounded-xl border-2 border-dashed border-current px-4 py-3" data-id="element-187" data-mp="1lxd5o76cz80w">
            <span className="text-[10px] font-semibold uppercase tracking-[0.12em]" data-id="element-188" data-mp="1qpn46bljhges">Ex libris</span>
            <span className="text-[22px] font-semibold leading-[1.1]" data-id="element-189" data-mp="1vn6gv72l9l4m">{OWNER_NAME}</span>
          </div>
          <span className="text-center text-[13px] font-semibold leading-tight" data-id="element-190" data-mp="y20t6i9zf9hw">{book.title}</span>
        </div>
      </div>
    </div>;
}
export function BookPile({
  order,
  openId,
  onPick,
  onClose
}: BookPileProps) {
  const topId = order[order.length - 1];
  return <>
      <div className="ct-pile" data-id="element-191" data-mp="1cz1k4jkcn0fb">
        {books.map((b, id) => {
        const isTop = id === topId;
        return <button key={b.title} type="button" className={`ct-cover${isTop ? ' ct-cover-top' : ''}`} onClick={() => onPick(id)} aria-pressed={id === openId} aria-label={`Open ${b.title} by ${b.author}`} style={{
          left: b.x,
          top: b.y,
          zIndex: order.indexOf(id) + 1,
          background: b.bg,
          color: b.fg,
          transform: `rotate(${b.rot}deg)` + (isTop ? ' translateY(-6px) scale(1.03)' : '')
        }} data-id="element-192" data-mp="2jfn0hm1z5l61" data-mpi={id}>
              <span className="text-[22px] font-semibold leading-[1.15] tracking-[-0.01em]" data-id="element-193" data-mp="3p4c86haouvc9">{b.title}</span>
              <span aria-hidden="true" className="self-center" style={{
            width: b.motif.w,
            height: b.motif.h,
            borderRadius: b.motif.radius,
            background: b.motif.color,
            boxShadow: b.motif.shadow
          }} data-id="element-194" data-mp="3g5z6sq8dh7sh" />
              <span className="text-[11.5px] font-semibold uppercase tracking-[0.08em]" data-id="element-195" data-mp="19g2io8j7427r">{b.author}</span>
            </button>;
      })}
        {openId >= 0 && <OpenBook key={openId} book={books[openId]} data-id="element-196" data-mp="b3zuvomaod2g" />}
      </div>

      {openId >= 0 ? <button type="button" onClick={onClose} className="inline-flex h-11 items-center rounded-full border border-[#E3E6E3] bg-[#FFFFFF] px-5 text-sm font-medium text-[#1B2220] transition-[border-color,transform] duration-150 ease-out hover:border-[rgba(30,75,72,0.4)] active:scale-[0.97]" data-id="element-197" data-mp="3t9uqw6uwxymt">
          Close the book
        </button> : <p className="text-sm font-medium text-[#1E4B48]" data-id="element-198" data-mp="3aj3j39qkqgaj">Tap a book to open it.</p>}
    </>;
}